
export default class WebPhoneListener {
    static Events = [
        `invite`,
        `terminated`
    ];
    constructor(client, emitter, user) {
        this.emitter = emitter;
        this.client = client;
        this.register();
        this.emitter = emitter;
        this.user = user;
    }

    /**
     * Listening all UA events
     */
    register() {
        WebPhoneListener.Events.forEach(event => this.client.on(event, args => this.onEvent(event, args)))
    }

    /**
     * Broadcast all events to vuejs environment
     */

    onEvent(event, args) {
        try {
            //Bora emitir o evento para o state
            this.emitter.emit(event, args);
        } catch (error) {
            console.error(error);
        }


    }
}